import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from './../../fetch';
import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';

import { GET_COUPONS, GET_COUPONS_SUCCESS, GET_COUPONS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant';

function* getCoupons({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/coupons`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({ type: GET_COUPONS_SUCCESS, payload: response?.data });
    } else {
      yield put({ type: GET_COUPONS_ERROR, payload: response.data.message });
    }
  } catch (error) {
    yield put({ type: GET_COUPONS_ERROR, payload: error });
  }
}

export function* watchGetCoupons() {
  yield takeEvery(GET_COUPONS, getCoupons);
}

function* getCouponsSaga() {
  yield all([fork(watchGetCoupons)]);
}

export default getCouponsSaga;
